import { render, staticRenderFns } from "./SubSectionStandartHead.vue?vue&type=template&id=0c1e90ce&"
import script from "./SubSectionStandartHead.vue?vue&type=script&lang=js&"
export * from "./SubSectionStandartHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports